import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { useTheme } from '../../contexts/ThemeContext';

interface DeleteConfirmDialogProps {
  open: boolean;
  itemTitle: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

export const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  open,
  itemTitle,
  onClose,
  onConfirm,
}) => {
  const { theme } = useTheme();
  const [deleting, setDeleting] = useState(false);

  const handleConfirm = async () => {
    try {
      setDeleting(true);
      await onConfirm();
    } catch (error) {
      console.error('Erro ao excluir:', error);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={deleting ? undefined : onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon sx={{ color: '#d32f2f' }} />
          Confirmar Exclusão
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography>
          Tem certeza que deseja remover <strong>"{itemTitle}"</strong> da sua wishlist?
        </Typography>
        <Typography sx={{ mt: 1, fontSize: '0.875rem', color: theme.colors.text.secondary }}>
          Esta ação não pode ser desfeita.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={deleting}>
          Cancelar
        </Button>
        <Button 
          onClick={handleConfirm}
          disabled={deleting}
          variant="contained"
          sx={{
            backgroundColor: '#d32f2f',
            '&:hover': {
              backgroundColor: '#b71c1c',
            },
            '&:disabled': {
              backgroundColor: '#d32f2f',
              opacity: 0.6,
            },
          }}
        >
          {deleting ? (
            <CircularProgress size={20} sx={{ color: 'white' }} />
          ) : (
            'Excluir'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
